export default class BrokerFirm {
    constructor() {
        this.id;
        this.name;
        this.brokerFirmStatus;
        this.brokerIds = [];
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.name = setEntity.name;
        this.brokerFirmStatus = setEntity.brokerFirmStatus;
        this.brokerIds = setEntity.brokerIds ? setEntity.brokerIds : [];
        return this;
    }
}
